var React = require('react');

function LeftChevron (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.642.779.806 6.295a.964.964 0 0 0 0 1.41l5.836 5.517c.392.37 1.016.37 1.409 0l.087-.093c.319-.39.29-.96-.087-1.316L3.101 7l4.955-4.818A.963.963 0 0 0 8.051.779a1.03 1.03 0 0 0-1.41 0Z","fillRule":"nonzero"}));
}

LeftChevron.defaultProps = {"viewBox":"0 0 9 14"};

module.exports = LeftChevron;

LeftChevron.default = LeftChevron;
